'use client';

import { useWbsStore } from '@/stores/wbsStore';

export default function Dashboard() {
  const { stats } = useWbsStore();

  if (!stats) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[1, 2, 3].map((i) => (
          <div key={i} className="bg-white rounded-xl p-6 shadow-sm animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-24 mb-4"></div>
            <div className="h-8 bg-gray-200 rounded w-16"></div>
          </div>
        ))}
      </div>
    );
  }

  const cards = [
    {
      title: '전체 공정율',
      value: stats.total_progress,
      color: 'blue',
      icon: '📈',
    },
    {
      title: '금주 공정율',
      value: stats.week_progress,
      color: 'green',
      icon: '📊',
    },
    {
      title: '작업 현황',
      value: null,
      color: 'purple',
      icon: '📋',
      statusCounts: stats.status_counts,
    },
  ];

  return (
    <section className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
      {/* 전체 공정율 */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-gray-500 text-sm font-medium">전체 공정율</h3>
          <span className="text-xs text-gray-400">2025.11.03 ~ 2026.04.30</span>
        </div>
        <div className="flex items-end space-x-2 mb-3">
          <span className="text-4xl font-bold text-[#1e40af]">{stats.total_progress}</span>
          <span className="text-2xl text-gray-400">%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-3">
          <div
            className="bg-[#1e40af] h-3 rounded-full transition-all duration-500"
            style={{ width: `${stats.total_progress}%` }}
          />
        </div>
      </div>

      {/* 주차 공정율 */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-gray-500 text-sm font-medium">이번 주 공정율</h3>
          <span className="text-xs text-gray-400"></span>
        </div>
        <div className="flex items-end space-x-2 mb-3">
          <span className="text-4xl font-bold text-[#3b82f6]">{stats.week_progress}</span>
          <span className="text-2xl text-gray-400">%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-3">
          <div
            className="bg-[#3b82f6] h-3 rounded-full transition-all duration-500"
            style={{ width: `${stats.week_progress}%` }}
          />
        </div>
      </div>

      {/* 단계별 현황 */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-gray-500 text-sm font-medium">진행 현황</h3>
          <span className="text-xs text-gray-400">작업 상태별</span>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="flex items-center space-x-2">
            <span className="w-3 h-3 rounded-full bg-[#9ca3af]"></span>
            <span className="text-sm text-gray-600">시작전</span>
            <span className="text-sm font-bold text-gray-800">{stats.status_counts?.before || 0}</span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="w-3 h-3 rounded-full bg-[#3b82f6]"></span>
            <span className="text-sm text-gray-600">진행중</span>
            <span className="text-sm font-bold text-gray-800">{stats.status_counts?.progress || 0}</span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="w-3 h-3 rounded-full bg-[#f97316]"></span>
            <span className="text-sm text-gray-600">컨펌중</span>
            <span className="text-sm font-bold text-gray-800">{stats.status_counts?.confirm || 0}</span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="w-3 h-3 rounded-full bg-[#22c55e]"></span>
            <span className="text-sm text-gray-600">완료</span>
            <span className="text-sm font-bold text-gray-800">{stats.status_counts?.complete || 0}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
